import { render, staticRenderFns } from "./HouseComponentDefectForm.vue?vue&type=template&id=5829ebcb&"
import script from "./HouseComponentDefectForm.vue?vue&type=script&lang=js&"
export * from "./HouseComponentDefectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports